;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.entity.show')
    .controller('EntityShowController', EntityShowController)

  EntityShowController.$inject = [
    // Angular
    '$state', '$uibModal',

    // Services
    'UtilService', 'SnackService', 'PreferencesService', 'ExportService',

    // Managers
    'BalanceManager', 'InvoiceManager', 'QuoteManager', 'CreditNoteManager', 'CustomFieldManager',

    // Resolve
    'invoicePagination', 'quotePagination', 'creditNotePagination', 'entity', 'path', 'generalPrefs'

  ]

  function EntityShowController (
    // Angular
    $state, $uibModal,
    // Services
    UtilService, SnackService, PreferencesService, ExportService,
    // Managers
    BalanceManager, InvoiceManager, QuoteManager, CreditNoteManager, CustomFieldManager,
    // Resolve
    invoicePagination, quotePagination, creditNotePagination, entity, path, generalPrefs
  ) {
    var self = this

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        entity: entity,
        path: path,
        displayActivity: !!_.get(generalPrefs, 'settings.edition.displayActivity', false), // double négation pour découpler de generalPrefs
        delays: [
          { label: 'À réception de facture', value: 0 },
          { label: '10', value: 10 },
          { label: '15 ', value: 15 },
          { label: '30', value: 30 },
          { label: '45', value: 45 },
          { label: '53', value: 53 },
          { label: '60', value: 60 }
        ],
        creditInvoiceColumns: [
          { id: 'number', label: 'Numéro' },
          { id: 'date', label: 'Émission' },
          { id: 'dueDate', label: 'Échéance' },
          { id: 'status', label: 'État' },
          { id: 'balanceDue', label: 'Balance' },
          { id: 'fullTotal', label: 'TTC' }
        ],
        quoteColumns: [
          { id: 'number', label: 'Numéro' },
          { id: 'date', label: 'Émission' },
          { id: 'dueDate', label: 'Échéance' },
          { id: 'status', label: 'État' },
          { id: 'fullTotal', label: 'TTC' }
        ],
        priceAdjustment: [
          { label: 'OUI', value: true },
          { label: 'NON', value: false },
        ],
        invoicePagination: invoicePagination,
        quotePagination: quotePagination,
        creditNotePagination: creditNotePagination,

        // Methods
        exportPayment: exportPayment,
        fullTotalFallback: fullTotalFallback,
        goTo: goTo,
        getInvoiceNumber: getInvoiceNumber,
        getQuoteNumber: getQuoteNumber,
        getCreditNoteNumber: getCreditNoteNumber,
        getDateColor: getDateColor,
        getInvoiceList: getInvoiceList,
        getCreditNoteList: getCreditNoteList,
        getQuoteList: getQuoteList,
        sortInvoices: sortInvoices,
        sortQuotes: sortQuotes,
        sortCreditNotes: sortCreditNotes,
        initChildren: initChildren,
        save: save,
        createNew: createNew,
        updateCustomFields: updateCustomFields,
        setDelay: setDelay
      })

      init()
    }

    function init () {
      getInvoiceList()
      // getTotalInvoiceList()
      getQuoteList()
      getCreditNoteList()
      getBalance()
      initChildren()
      getCustomFields()
    }

    function sortInvoices (name) {
      this.reverse = (self.invoicePagination.orderBy === name) ? !this.reverse : false
      self.invoicePagination.orderBy = name
      self.invoicePagination.reverse = this.reverse
      getInvoiceList()
    }

    function sortQuotes (name) {
      this.reverse = (self.quotePagination.orderBy === name) ? !this.reverse : false
      self.quotePagination.orderBy = name
      self.quotePagination.reverse = this.reverse
      getQuoteList()
    }

    function sortCreditNotes (name) {
      this.reverse = (self.creditNotePagination.orderBy === name) ? !this.reverse : false
      self.creditNotePagination.orderBy = name
      self.creditNotePagination.reverse = this.reverse
      getCreditNoteList()
    }

    function exportPayment () {
      return ExportService.paymentAsSpreadsheet(self.entity._id)
    }

    function initChildren () {
      self.children = _.sortBy(_.map(_.groupBy(_.filter(entity.children, function (elt) {
        return elt.__t !== 'Area' && elt.__t !== 'Housing'
      }), function (c) {
        return c.__t
      }), function (value, key) {
        var name
        switch (key) {
          case 'Organization':
            name = 'Organisation'
            break
          case 'Agency':
            name = 'Agence'
            break
          case 'professional':
            name = 'Contact Professionnel'
            break
          case 'individual':
            name = 'Particulier'
            break
          default:
            name = key
        }
        return {
          type: key,
          name: name,
          entities: value
        }
      }), function (e) {
        return _.indexOf(['Agency', 'professional', 'Area', 'Housing'], e.type)
      })
    }

    function goTo (concern) {
      var config = {
        client: self.entity._id,
        label: self.entity.label
      }
      $state.go(concern + '.list', { linkedSearch: config })
    }

    function save () {
      self.entity.save().then(function () {
        SnackService.snack({
          text: 'Changements sauvegardés !',
          delay: 5000
        })
        self.clientForm.$setPristine()
      })
    }

    function setDelay (type) {
      self.entity[type] = false
    }

    function createNew (concern) {
      switch (concern) {
        case 'invoice':
          return PreferencesService.getPrefsFor('invoice').then(function (prefs) {
            let dueDate = moment(new Date()).add(prefs.invoiceDelay, 'days').toDate()
            if (entity.paymentDelay) {
              dueDate = moment(new Date()).add(entity.paymentDelay, 'days').toDate()
            }
            if (entity.paymentDelayEndOfMonth) {
              dueDate = moment(new Date()).add(entity.paymentDelayEndOfMonth, 'days').toDate()
            }
            let invoice = InvoiceManager.create({
              client: self.entity._id
            })
            invoice.date = moment().toDate()
            invoice.dueDate = dueDate
            invoice.thanks = prefs.defaultThanks
            invoice.conditions = prefs.defaultConditions
            $state.go('invoice.new', { initParams: invoice })
          })
        case 'quote':
          return PreferencesService.getPrefsFor('quote').then(function (prefs) {
            let quote = QuoteManager.create({
              client: self.entity._id
            })
            quote.date = moment().toDate()
            quote.dueDate = moment(new Date()).add(prefs.quoteDelay, 'days').toDate()
            quote.thanks = prefs.defaultThanks
            quote.conditions = prefs.defaultConditions
            $state.go('quote.new', { initParams: quote })
          })
      }
    }

    /* function getPayments () {
      return _.flatten(_.map(self.invoices, function (invoice) {
        if (invoice.payments) {
          return _.map(invoice.payments, function (value) {
            return {date: new Date(value.date), amount: value.amount.amount}
          })
        }
      }))
    } */

    function getInvoiceNumber (invoice) {
      if (invoice.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(invoice, 'invoice', invoice.numberFormat)
    }

    function getQuoteNumber (quote) {
      if (quote.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(quote, 'quote', quote.numberFormat)
    }

    function getCreditNoteNumber (creditNote) {
      if (creditNote.status === 'draft') return 'Brouillon'
      return UtilService.getInvoiceNumber(creditNote, 'creditnote', creditNote.numberFormat)
    }

    function getFullTotal (invoice) {
      var vats = _.reduce(invoice.lines,
        function (acc, line) {
          if (line.type === 'label') return acc
          var vat = line.VAT
          var vatTotal = _.find(acc, { vat: vat })
          if (!vatTotal) {
            vatTotal = { vat: vat, amount: 0 }
            acc.push(vatTotal)
          }
          vatTotal.amount += line.total * line.VAT / 100
          return acc
        }, [])
      var total = _.reduce(invoice.lines,
        function (acc, line) {
          if (line.type === 'label') return acc
          return acc + line.total
        }, 0)
      return total + _.reduce(vats, function (acc, vat) { return acc + vat.amount }, 0)
    }

    function fullTotalFallback (invoice) {
      if (!invoice.fullTotal || (invoice.fullTotal === 0 && invoice.total !== 0)) {
        return getFullTotal(invoice)
      }
      return invoice.fullTotal
    }

    function getDateColor (invoice) {
      if (invoice.status !== 'paid') {
        if (moment().isAfter(moment(invoice.dueDate))) {
          return 'red'
        } else if (moment(invoice.dueDate).subtract(5, 'days') < moment()) {
          return 'orange'
        }
      }
    }

    function getBalanceSummary () {
      var debitLines = _.compact(_.map(self.totalInvoices, function (value) {
        if (value.balanceDue && value.status !== 'paid' && value.status !== 'draft' && value.balanceDue !== 0) {
          return { date: new Date(value.date), debit: value.balanceDue }
        }
      }))
      var creditLines = _.compact(_.map(self.totalCreditNotes, function (value) {
        if (value.status !== 'paid' && value.status !== 'draft') {
          return { date: new Date(value.date), credit: -value.balanceDue }
        }
      }))
      var lines = debitLines.concat(creditLines)
      return lines.sort(function (a, b) {
        return a.date - b.date
      }).reverse()
    }

    /*  function getDetailedBalanceSummary () {
        var debitLines = _.map(self.payments, function (value) {
          return {date: value.date, debit: value.amount}
        })
        var creditLines = _.compact(_.map(self.creditNotes, function (value) {
          if (value.status === 'paid') {
            return {
              date: new Date(_.get(_.find(value.history, function (h) { return h.status === 'sent' }), 'date')),
              credit: value.fullTotal
            }
          }
        }))
        var lines = debitLines.concat(creditLines)
        return lines.sort(function (a, b) {
          return a.date - b.date
        })
      } */

    function getBalance () {
      var balanceQuery = BalanceManager
        .query()
        .select(entity._id, 'client')

      BalanceManager.get(balanceQuery).then(function (balanceData) {
        self.totalBalance = balanceData.data[0]
      })
    }

    function getTotalInvoiceList () {
      var query =
        InvoiceManager
          .query()
          .select(self.entity._id, 'client')
      // .fields('date status balanceDue lines')

      self.loading = true
      InvoiceManager.getAllByBatch(query).then(function (data) {
        self.totalInvoices = data.data

        var creditNoteQuery =
          CreditNoteManager
            .query()
            // .select(_.map(data.data, '_id'), 'invoiceRef')
            .select(self.entity._id, 'client')
        // .fields('date status balanceDue numberFormat number lines')

        CreditNoteManager.getAllByBatch(creditNoteQuery).then(function (creditNoteData) {
          self.totalCreditNotes = creditNoteData.data
          self.balanceLines = getBalanceSummary()
          self.loading = false
        })
      })
    }

    function getCreditNoteList () {
      var creditNoteQuery = CreditNoteManager
        .query()
        .select(self.entity._id, 'client')
        // .fields('_id number date dueDate status balanceDue fullTotal numberFormat lines isArchived payments')
        .archived('both')
        .paginate(self.creditNotePagination.toQueryOptions())

      self.loading = true
      CreditNoteManager.post(creditNoteQuery).then(function (data) {
        self.creditNotes = data.data
        self.creditNotePagination.totalElements = data.meta.total
        self.loading = false
      })
    }

    function getInvoiceList () {
      var query =
        InvoiceManager
          .query(
            {
              conditions: { isModel: { $ne: true } }
            }
          )
          .select(self.entity._id, 'client')
          // .fields('_id number date dueDate status balanceDue fullTotal numberFormat lines isArchived payments globalDic')
          .paginate(self.invoicePagination.toQueryOptions())
          .archived('both')

      self.loading = true
      InvoiceManager.get(query).then(function (data) {
        self.invoices = data.data
        self.invoicePagination.totalElements = data.meta.total
        self.loading = false
        // self.payments = getPayments()
      })
    }

    function getQuoteList () {
      var query =
        QuoteManager
          .query(
            {
              conditions: { isModel: { $ne: true } }
            }
          )
          .select(self.entity._id, 'client')
          // .fields('_id number date dueDate status fullTotal numberFormat lines isArchived payments')
          .paginate(self.quotePagination.toQueryOptions())
          .archived('both')

      self.loading = true
      QuoteManager.get(query).then(function (data) {
        self.quotes = data.data
        self.quotePagination.totalElements = data.meta.total
        self.loading = false
      })
    }

    function getCustomFields () {
      self.customFieldsLoading = true
      CustomFieldManager.get(CustomFieldManager.query().select('Entity', 'model')).then(({ data }) => {
        self.customFields = data
        self.customFieldsLoading = false
      })
    }

    function updateCustomFields () {
      return $uibModal.open({
        controllerAs: '$ctrl',
        size: 'lg',
        bindToController: true,
        resolve: {
          customFields: function () { return self.customFields },
          model: function () { return angular.copy(self.entity.customFields) }
        },
        templateUrl: '/app/modules/entity/modals/modify-custom-fields/modify-custom-fields-modal.template.html',
        controller: 'ModifyCustomFieldsModalController'
      }).result.then((c) => {
        self.entity.customFields = c
        self.entity.save()
          .then(function () {
            getCustomFields()
            SnackService.snack({
              text: 'Champs personnalisés mis à jour',
              delay: 3000
            })
          })
      })
    }
  }
})(window.angular, window._, window.moment)
